var _a;
/* eslint-disable @typescript-eslint/naming-convention */
export var BuiltInErrorType;
(function (BuiltInErrorType) {
    /** 原生错误 */
    BuiltInErrorType["Native"] = "native";
    /** 网络错误 */
    BuiltInErrorType["Network"] = "network";
    /** 加密错误 */
    BuiltInErrorType["Encryption"] = "encryption";
    /** 自定义错误 */
    BuiltInErrorType["Custom"] = "custom";
})(BuiltInErrorType || (BuiltInErrorType = {}));
export var ErrorTypeCodeMap = (_a = {},
    _a[BuiltInErrorType.Native] = 11,
    _a[BuiltInErrorType.Network] = 16,
    _a[BuiltInErrorType.Encryption] = 90,
    _a[BuiltInErrorType.Custom] = -1,
    _a);
export var MediaElementNetworkErrorCode = [1 /** MEDIA_ERR_ABORTED */, 2 /** MEDIA_ERR_NETWORK */];
export var MediaElementPlaybackErrorCode = [3 /** MEDIA_ERR_DECODE */, 4 /** MEDIA_ERR_SRC_NOT_SUPPORTED */];
/**
 * 11103、11104的细分错误码枚举（bit位）
 */
export var MediaElementNativeDetail;
(function (MediaElementNativeDetail) {
    /** 不支持avc播放 */
    MediaElementNativeDetail[MediaElementNativeDetail["BaselineAVCNotSupported"] = 2] = "BaselineAVCNotSupported";
    /** 未开启硬件加速 */
    MediaElementNativeDetail[MediaElementNativeDetail["HardwareAcceleratedOff"] = 1] = "HardwareAcceleratedOff";
})(MediaElementNativeDetail || (MediaElementNativeDetail = {}));
